<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="languageSummary">
			<title-bar title="Idiomas" :percentage="languageSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="languageSummary.itemName" :percentage="languageSummary.itemPercentage" percentageTitle="Promedio Idioma"/>
			<div class="col full">
				<div class="row between innerRubric">
					<percentages-summary v-for="coachingCategory in languageSummary.coachingCategories" :key="coachingCategory.id" :coachingCategory="coachingCategory"></percentages-summary>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import mediator from '@/mediator';
export default {
	props: ['isoCode'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		languageSummary () {
			if (this.$store.state.languages.summary) return this.$store.state.languages.summary.find((item) => {
				return item.itemId == this.isoCode;
			});
			else return this.$store.state.languages.summary;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/languages/Summary.vue